import { capitalizeWords } from '@doveit/hammer';
import { Agent } from '../../providers/api/dtos';

export default function getShortAgentName(agentName: Agent['name']) {
  return `${agentName.name.charAt(0).toUpperCase()}. ${capitalizeWords(agentName.surname)}`;
}
